<template>
  <div class="post-layout rounded bg-white py-3 mt-2"><slot></slot></div>
</template>

<script>
export default {};
</script>

<style scoped>
.post-layout {
  box-shadow: 0px 3px 6px #9dceff29;
}
</style>
